import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import CustomOrder from "@/pages/CustomOrder";
import CustomCovers from "@/pages/CustomCovers";
import CoverBuilder from "@/pages/CoverBuilder";
import Reviews from "@/pages/Reviews";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Admin from "@/pages/admin/Admin";
import QuotePage from "@/pages/QuotePage";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route path="/quote/:token" element={<QuotePage />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/covers" element={<CustomCovers />} />
          <Route path="/covers/:fabricId" element={<CoverBuilder />} />
          <Route path="/cowhide" element={<CustomCovers />} />
          <Route path="/build-your-cover" element={<CustomCovers />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about" element={<About />} />
          <Route path="/custom-order" element={<CustomOrder />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
